<script lang="ts">
	import { rowActions } from '@repo/commons/components'
	import { Button, ButtonType } from '@repo/commons/components'

	interface Props {
		row: Record<string, string>
		onActionHandler: ((action: rowActions, id: string) => void) | null
	}

	let { row, onActionHandler = null }: Props = $props()

	const actions = $derived(
		(row.actions as unknown as rowActions[]) || Array.from(Object.values(rowActions))
	)
	const disabledActions = $derived((row.disabledActions as unknown as rowActions[]) ?? [])

	const Buttons: Record<rowActions, any> = {
		[rowActions.EDIT]: {
			icon: 'edit',
			action: rowActions.EDIT
		},
		[rowActions.DELETE]: {
			icon: 'trash',
			action: rowActions.DELETE
		},
		[rowActions.COPY]: {
			icon: 'copy',
			action: rowActions.COPY
		},
		[rowActions.DOWNLOAD]: {
			icon: 'download',
			action: rowActions.DOWNLOAD
		},
		[rowActions.UPLOAD]: {
			icon: 'upload',
			action: rowActions.UPLOAD
		},
		[rowActions.MORE]: {
			icon: 'more',
			action: rowActions.MORE
		},
		[rowActions.DUPLICATE]: {
			icon: 'copy',
			action: rowActions.DUPLICATE
		},
		[rowActions.NAVIGATE]: {
			icon: 'releaseVersion',
			action: rowActions.NAVIGATE
		}
	}

	const handleClick = (action: rowActions, id: string) => {
		onActionHandler?.(action, id)
	}
</script>

<div class="label-container">
	{#each actions as action}
		{#if Buttons[action]}
			<Button
				buttonText=""
				buttonType={ButtonType.TERTIARY_INVERSE}
				iconProps={{ name: Buttons[action].icon, size: 'md', class: 'text-[#002C4D80]' }}
				disabled={disabledActions.includes(action)}
				onclick={() => handleClick(action, row.id)}
				rounded
			/>
		{/if}
	{/each}
</div>

<style lang="postcss">
	.label-container {
		@apply flex items-center gap-1;
	}
</style>
